module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-HIPPO-Flood.f14a5d29.gif";